import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import img1 from "../../assets/images/icon/BestCare.webp";
import img2 from "../../assets/images/icon/Flexibly.webp";
import img3 from "../../assets/images/icon/Methods.webp";
import img4 from "../../assets/images/icon/ChildrenSkills.webp";

const Feature = () => {
  const { t } = useTranslation();

  return (
    <div
      className="feature-area bg-[url('../images/all-img/section-bg-15.png')] bg-cover bg-no-repeat bg-center section-padding"
      style={{ marginTop: "120px", marginBottom: "120px" }}
    >
      <div className="container">
        <div className="text-center">
          <div className="mini-title">{t("feature.mini_title")}</div>
          <div className="column-title">
            {t("feature.title").split(" ")[0]}{" "}
            <span className="shape-bg">{t("feature.title").split(" ")[1]}</span>{" "}
            {t("feature.title").split(" ").slice(2).join(" ")}
          </div>
        </div>

        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-[30px] pt-10">
          {/* Feature 1 */}
          <Link to="/about" className="group">
            <div className="bg-white shadow-box rounded-[8px] p-10 group hover:bg-primary transition duration-150 hover:-translate-y-1 h-full">
              <div className="h-[72px] w-[72px] rounded-full flex items-center justify-center bg-green-paste mb-8 group-hover:bg-black group-hover:bg-opacity-[0.1] transition duration-150">
                <img
                  src={img1}
                  alt="Feature 1"
                  className="h-full w-full object-contain"
                />
              </div>
              <h4 className="lg:text-2xl text-[22px] leading-[30px] mb-4 group-hover:text-white transition duration-150">
                {t("feature.1.title")}
              </h4>
            </div>
          </Link>

          {/* Feature 2 */}
          <Link to="/about" className="group">
            <div className="bg-white shadow-box rounded-[8px] p-10 group hover:bg-primary transition duration-150 hover:-translate-y-1 h-full">
              <div className="h-[72px] w-[72px] rounded-full flex items-center justify-center bg-green-paste mb-8 group-hover:bg-black group-hover:bg-opacity-[0.1] transition duration-150">
                <img
                  src={img2}
                  alt="Feature 2"
                  className="h-full w-full object-contain"
                />
              </div>
              <h4 className="lg:text-2xl text-[22px] leading-[30px] mb-4 group-hover:text-white transition duration-150">
                {t("feature.2.title")}
              </h4>
            </div>
          </Link>

          {/* Feature 3 */}
          <Link to="/about" className="group">
            <div className="bg-white shadow-box rounded-[8px] p-10 group hover:bg-primary transition duration-150 hover:-translate-y-1 h-full">
              <div className="h-[72px] w-[72px] rounded-full flex items-center justify-center bg-green-paste mb-8 group-hover:bg-black group-hover:bg-opacity-[0.1] transition duration-150">
                <img
                  src={img3}
                  alt="Feature 3"
                  className="h-full w-full object-contain"
                />
              </div>
              <h4 className="lg:text-2xl text-[22px] leading-[30px] mb-4 group-hover:text-white transition duration-150">
                {t("feature.3.title")}
              </h4>
            </div>
          </Link>

          {/* Feature 4 */}
          <Link to="/about" className="group">
            <div className="bg-white shadow-box rounded-[8px] p-10 group hover:bg-primary transition duration-150 hover:-translate-y-1 h-full">
              <div className="h-[72px] w-[72px] rounded-full flex items-center justify-center bg-green-paste mb-8 group-hover:bg-black group-hover:bg-opacity-[0.1] transition duration-150">
                <img
                  src={img4}
                  alt="Feature 4"
                  className="h-full w-full object-contain"
                />
              </div>
              <h4 className="lg:text-2xl text-[22px] leading-[30px] mb-4 group-hover:text-white transition duration-150">
                {t("feature.4.title")}
              </h4>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Feature;
